import { CATEGORY_PAGE } from "../../state/modules/page/constants";
import { searchOptions, categoryOptions } from "../../state/data/sort";

export const options = (pageName) =>
  pageName === CATEGORY_PAGE ? categoryOptions : searchOptions;

export const queryParams = (pageName) =>
  options(pageName).map(({ value }) => value);
